import { Grid, IconButton, makeStyles, TextField } from '@material-ui/core';
import { AddCircleOutline, RemoveCircleOutline } from '@material-ui/icons';
import { useObserver } from 'mobx-react-lite';
import React, { FC, useState, ChangeEvent } from 'react';

const useStyles = makeStyles(() => ({
  conatainer: {
    flexWrap: 'nowrap'
  },
  quantityAction: {
    marginTop: 20
  },
  denseQuantityAction: {
    marginTop: 4
  },
  quantityField: {
    maxWidth: 160
  },
  denseQuantityField: {
    maxWidth: 108
  }
}));

interface QuantityFieldProps {
  value?: number;
  onChange?: (quantity: number) => void;
  dense?: boolean;
  disabled?: boolean;
}

const QuantityField: FC<QuantityFieldProps> = ({
  value,
  dense,
  disabled,
  onChange
}: QuantityFieldProps) => {
  const classes = useStyles();
  const [quantity, setQuantity] = useState(`${value || 1}`);
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState('');

  const handleChange = (
    event: ChangeEvent<{ name?: string; value: unknown }>
  ) => {
    const value = event.target.value as string;
    event.preventDefault();

    let strValue = value;
    if (strValue.length === 0) {
      strValue = '1';
    } else if (strValue.length > 2) {
      strValue = value.substr(value.length - 2, 2);
    }
    let v = parseInt(strValue);
    if (v === 0) {
      v = 1;
    }
    if (v < 0) {
      v = -v;
    }
    setQuantity(`${v}`);
    setError(false);
    setHelperText('');
    if (onChange !== undefined) {
      onChange(v);
    }
  };

  const increase = () => {
    const q = parseInt(quantity);
    updateQuantity(q + 1);
  };

  const decrease = () => {
    const q = parseInt(quantity);
    updateQuantity(q - 1);
  };

  const updateQuantity = (quantity: number) => {
    if (quantity < 1 || quantity > 99) {
      return;
    }
    setError(false);
    setHelperText('');
    setQuantity(`${quantity}`);
    if (onChange !== undefined) {
      onChange(quantity);
    }
  };

  return useObserver(() => (
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="flex-start"
      spacing={1}
      className={classes.conatainer}
    >
      <Grid item>
        <IconButton
          size="medium"
          className={
            dense ? classes.denseQuantityAction : classes.quantityAction
          }
          onClick={decrease}
          disabled={disabled}
        >
          <RemoveCircleOutline />
        </IconButton>
      </Grid>
      <Grid item>
        <TextField
          className={dense ? classes.denseQuantityField : classes.quantityField}
          id="quantity"
          label="Quantity (1-99)"
          variant="outlined"
          value={quantity}
          onChange={handleChange}
          error={error}
          helperText={helperText}
          margin={dense ? 'dense' : 'normal'}
          disabled={disabled}
        />
      </Grid>
      <Grid item>
        <IconButton
          className={
            dense ? classes.denseQuantityAction : classes.quantityAction
          }
          onClick={increase}
          disabled={disabled}
        >
          <AddCircleOutline />
        </IconButton>
      </Grid>
    </Grid>
  ));
};

export default QuantityField;
